import React from "react";

const CoinsHeldCard = ({ data, index }) => {
  return (
    <div className="glass-effect coin-held-card" key={index}>
      <div>
        <div>
          <img src="/profile.png" alt="Coin" className="picture" />
        </div>
        <div className="text-data">
          <p>{data.CoinName}</p>
          <p>
            <span>{Number(data.volume).toFixed(4)}</span>{" "}
            <span>{data.chainName.toUpperCase()}</span>
          </p>
        </div>
      </div>
      <div>
        <img src="/icons/reload.svg" alt="Reload" className="reload-icon" />
        <button className="button-purple view-coin">View Coin</button>
      </div>
    </div>
  );
};

export default CoinsHeldCard;
